import Component from "../abstracts/Component";
import GiftcardFormComponent from "../components/GiftcardFormComponent";
import TrackingComponent from '../components/TrackingComponent';

export default class NotifyMeLogic extends Component {

  get SELECTORS() {
    return {
      main: '.js-addtocart',
      error: '.js-addtocart-notification',
      container: '.js-form-container',
      form: '.js-notify-me',
      giftcard: '.js-addtocart-giftcard',
      submitNotifyBtn: '.js-submit',
      addtowish: '.js-addremove-wishlist a'
    }
  }

  get CLASSES() {
    return {
      layerVisible: 'show'
    }
  }

  constructor() {
    super();

    this.mainTarget = $(this.SELECTORS.main);
    this.error =  $(this.SELECTORS.error);
    this.container = $(this.SELECTORS.container);
    this.form = $(this.SELECTORS.form);
    this.giftcard = $(this.SELECTORS.giftcard);
    this.submitNotifyBtn = $(this.SELECTORS.submitNotifyBtn);
    this.GiftcardFormComponent = new GiftcardFormComponent();
    this.TrackingComponent = new TrackingComponent();
  }

  enableBtn(button) {
    let baseCode = $(button).data('baseCode');
    let addtocart = $(`${this.SELECTORS.main}[data-code="${baseCode}"]`)
    let msg = this.mainTarget.data('addtocart-label');
    addtocart.removeClass('cta-selectsize');
    addtocart.find('span').text(msg);
    addtocart.data('enabled', true);
  }

  updateProductCode(button) {
    let $elem = $(button);
    let baseCode = $elem.data('baseCode');
    let variantCode = $elem.data('code');
    let addtocart = $(`${this.SELECTORS.main}[data-code="${baseCode}"]`);
    addtocart.data('code', variantCode );
    let addtowish = $(`${this.SELECTORS.addtowish}[data-code="${baseCode}"]`);
    addtowish.data('code', variantCode );
    this.log(variantCode);
  }

  // sizeNotification(ev) {
  //   let $elem = $(ev.payload);
  //   let msg = $elem.data('notification');
  //   $elem.addClass('cta-selectsize');
  //   $elem.find('span').text(msg);
  // }

  enableForm(code, baseCode) {
    let form =  $(`${this.SELECTORS.container}[data-code="${baseCode}"]`).find(this.SELECTORS.form);
    let cta = form.find('.jsSubmitNotify');
    form.find('#productcode').val(code);
  }

  showUnavailableForm(button) {
    let code = $(button).data('baseCode');
    $(`.notify-form[data-code="${code}"]`).addClass(this.CLASSES.show);
    if (this.$matchMedia('sm', null)) {
      this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {classes: 'dark', inModal: inQuickBuy});
      $(`${this.SELECTORS.main}[data-product-code="${code}"]`).data('enabled', false);
    }
  }

  hideUnavailableForm(button) {
    let code = $(button).data('baseCode');
    $(`.notify-form[data-code="${code}"]`).removeClass(this.CLASSES.show);
  }

  bindEvents() {
    let ctx = this;

    //click on addtocart
    $('body').on('click.addToCart', ctx.SELECTORS.main, function(e) {
      e.preventDefault();

      let $this = $(this);
      let elemData = $this.data();
      let sendRequest = elemData.enabled || elemData.uniqueSize ;

     if(!sendRequest) {
       ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizerequired, $this)
     } else {
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addtocart, {button: $this})
      }
    });

    //click on addtocart giftcard
    $('body').on('click.addToCartGiftcard', ctx.SELECTORS.giftcard, function(e) {
      e.preventDefault();

      let $this = $(this);
      var form = $this.closest('form');
      var elemData = form.serialize();
      var trackData = {'formId': form.prop('id')};
      ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
        button: $this,
      });
      $this.attr("disabled", true);
      $.ajax({
        type : "post",
        url : form.attr('action'),
        data : elemData,
        contentType : "application/x-www-form-urlencoded",
        success : function(responseData, textStatus, jqXHR) {
          form.html(responseData);
          ctx.GiftcardFormComponent.initFormHandler();
          if(responseData.indexOf('data-result="error"') > 0) {
            window.scroll({
             top: 0,
             left: 0,
             behavior: 'smooth'
            });
            return;
          }
          if ($('#giftcardAddedAmount') != null && $('#giftcardAddedAmount').val() != null ) {
            ctx.TrackingComponent.actions.addCartGiftCard($('#giftcardAddedAmount').val());
          }
          ctx.$emit(ctx.$customEvents.PAGE_LAYOUT_EVENTS.changed);
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, { button: $this} )
          // TODO logiche di animazione di wip da insierire, apertura layer cart e cambio label cta
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtocart);
        },
        error : function(jqXHR, textStatus, errorThrown) {
          $this.attr("disabled", false);
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, { button: $this} )
          // TODO logiche di animazione di wip da insierire
        }
      })

    });

    // this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, (e) => {
    //   this.sizeNotification(e);
    // });

    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {
      ctx.updateProductCode(payload.button);
      ctx.hideUnavailableForm(payload.button);
      if (!$(payload.button).data('disabled')) {
        ctx.enableBtn(payload.button);
      }
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.addtocart, ({event, payload}) => {

      let $elem = $(payload.button);
      this.$emit(this.$customEvents.LOADER_EVENTS.showLocal, {
        button: $elem,
      });

      $elem.attr("disabled", true);

      $.ajax({
        url: $elem.data('href'),
        data: $elem.data(),
        dataType: "html",
        success: function (data) {
          if(data == 650){
            var remoteHref = $elem.data('exceeded-cart-qty');
            if(!isNaN($elem.data('product-code'))){
              remoteHref = remoteHref + $elem.data('product-code');
            }else if(!isNaN($elem.data('base-code'))){
              remoteHref = remoteHref + $elem.data('base-code');
            }else{
              remoteHref = remoteHref + $elem.data('code');
            }

            $.ajax({
              url: remoteHref,
              dataType: "html",
              success: function(html) {
                $elem.attr("disabled", false);
                ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                  unsafeContent: html,
                  modalClass: 'exceeded-cart-products'
                })
                console.info("[AddToCart] Exceed product max number on cart.")
              },
              error: function(xhr) {
                $elem.attr("disabled", false);
                console.error("[AddToCart]", xhr, arguments);
              }
            });
          }else {
            $elem.attr("disabled", false);
            // TODO logiche di animazione di wip da insierire
            console.log(data);
            let inWishlistLayer = payload.inWishlistLayer;
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtocart, {
              button: $elem,
              inWishlistLayer: inWishlistLayer
            });
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtocart);
          }
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, { button: $elem} );
          ctx.$emit(ctx.$customEvents.SIZES_EVENTS.sizesclose, { layer: $('.js-sizes') } );
          ctx.$emit(ctx.$customEvents.MENU_EVENTS.hideMenu, {time:3000}, '.action--quickcart' );
        },
        error: function (xhr) {
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, { button: $elem} )

          if (xhr.status == '510') {

            var remoteHref = $elem.data('remote-unavailable') + $elem.data('code');

            $.ajax({
              url: remoteHref,
              dataType: "html",
              success: function(html) {
                $elem.attr("disabled", false);
                ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                  unsafeContent: html,
                  modalClass: 'product-not-available'
                })
              },
              error: function(xhr) {
                $elem.attr("disabled", false);
                console.error("[AddToCart]", xhr, arguments);
              }
            });

          } else {
            //ctx.error.html(xhr.responseText);
            $elem.attr("disabled", false);
            ctx.error.html('Error in addtocart');
            console.error("[AddToCart]", xhr, arguments);
          }
        }
      });

    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.notifyme, ({event, payload}) => {
    	ctx.showUnavailableForm(payload);
    });

    $('body').on('submit', ctx.SELECTORS.form, function(e) {

        e.preventDefault();
        let $form = $(this);
        let url = $form.attr('action');
        let $submitNotifyBtn = $form.find(ctx.SELECTORS.submitNotifyBtn);

        if ($form.find('#email').val()) {
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, { button: $submitNotifyBtn});
        }

        $.ajax({
          type: "POST",
          url: url,
          data: $form.serialize(),
          success: function(message){
            ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, { button: $submitNotifyBtn} );

            $submitNotifyBtn.removeClass('error');
            $submitNotifyBtn.addClass('sent');
            setTimeout( ()=>{
            	$submitNotifyBtn.removeClass('sent');
            },2500);
          },
          error: function(xhr){
            ctx.log('notifyMe submit error ');
            $submitNotifyBtn.addClass('error');
        }
      });

      });

    //SET PRODUCT CODE TO INPUT ON SIZE CHANGE
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifyme, ({event, payload}) => {

      //remove size layer, set code and open notifyme
      let code = $(payload).data('code');
      let baseCode =  $(payload).data('baseCode');
      this.enableForm(code, baseCode);

    })

  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }

}

